<template>
  <b-card>
    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <InputField
            id="full-name"
            v-model="fullName"
            :label="$t('Full Name')"
            type="text"
            readonly
          />
        </b-col>
        <b-col sm="6">
          <InputField
            id="email"
            v-model="userData.email"
            :label="$t('Email')"
            type="text"
            readonly
          />
        </b-col>
        <b-col sm="6">
          <InputField
            id="company"
            v-model="userData.institutionName"
            :label="$t('Company')"
            type="text"
            readonly
          />
        </b-col>

        <b-col sm="6">
          <InputField
            id="branch"
            v-model="userData.branch"
            :label="$t('Branch')"
            type="text"
            readonly
          />
        </b-col>

        <b-col sm="6">
          <InputField
            id="designation"
            v-model="userData.designation"
            :label="$t('Designation')"
            type="text"
            readonly
          />
        </b-col>

        <b-col sm="6">
          <InputField
            id="role"
            v-model="userData.role"
            :label="$t('Role')"
            type="text"
            readonly
          />
        </b-col>

        <b-col sm="6">
          <InputField
            id="scopeLimit"
            v-model="userData.scopeLimit"
            :label="$t('Scope Limit')"
            type="text"
            readonly
          />
        </b-col>

        <b-col sm="6">
          <InputField
            id="phoneNumber"
            v-model="userData.phoneNumber"
            :label="$t('Phone Number')"
            type="text"
            readonly
          />
        </b-col>
        <b-col sm="6">
          <InputField
            id="employeeNumber"
            v-model="userData.employeeNumber"
            :label="$t('Employee Number')"
            type="text"
            readonly
          />
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BForm, BRow, BCol, BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import { mapGetters } from 'vuex'
import InputField from '../../forms/InputField.vue'

export default {
  components: {
    BForm,
    InputField,
    BRow,
    BCol,
    BCard,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      optionsLocal: JSON.parse(JSON.stringify(this.generalData)),
      profileFile: null,
      userProfile: {
        username: '',
        email: '',
        role: '',
        company: '',
        branch: '',
        accessLevel: '',
        employeeNumber: '',
        fullName: '',
        phoneNumber: '',
        scopeLimit: '',
        designation: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
    fullName() {
      return `${this.userData.lastname ?? ''} ${this.userData.firstname ?? ''} ${this.userData.othernames ?? ''}`
    },
  },
  methods: {
    resetForm() {
      this.optionsLocal = JSON.parse(JSON.stringify(this.generalData))
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, previewEl)

    return {
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>
